import { batch } from 'solid-js'
import { useDraftMoveSignal } from '../../../rx/signal/useDraftMoveSignal'
import { useSelectedPositionSignal } from '../../../rx/signal/useSelectedPositionSignal'
import { useSelectedToolSignal } from '../../../rx/signal/useSelectedToolSignal'
import calculateSelectedPositionEnts from '../entity/calculateSelectedPositionEnts'
import { SelectedToolId } from '../map_editor/SelectedToolId.enum'
import type { Engine } from './Engine.type'

export default function resetEngineToDefaultSelectedTool(engine: Engine) {
  // console.log('resetEngineToDefaultSelectedTool')
  // console.log('engine.draftMove = null')
  const [, setSelectedTool] = useSelectedToolSignal(engine)
  const [, setSelectedPosition] = useSelectedPositionSignal(engine)
  const [, setDraftMove] = useDraftMoveSignal(engine)

  batch(() => {
    setDraftMove(null)
    setSelectedTool(SelectedToolId.Inspect)
    setSelectedPosition(null)
    calculateSelectedPositionEnts(engine)
  })
}
